import type { Variants } from 'motion/react';

export const widgetStaggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.06, delayChildren: 0.1 },
  },
};

export const widgetStaggerItem: Variants = {
  hidden: { opacity: 0, y: 16, scale: 0.97 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { type: 'spring', stiffness: 300, damping: 24 },
  },
};

export const widgetJiggle: Variants = {
  idle: { rotate: 0 },
  jiggle: {
    rotate: [-0.8, 0.8, -0.8],
    transition: {
      duration: 0.3,
      repeat: Infinity,
      repeatType: 'mirror',
      ease: 'easeInOut',
    },
  },
};

export const focusExpand: Variants = {
  collapsed: { scale: 1, borderRadius: '16px' },
  expanded: {
    scale: 1,
    borderRadius: '0px',
    transition: { type: 'spring', stiffness: 200, damping: 25 },
  },
};
